/**
 * FoodContributionModal - Extracted from App.js Phase 4
 * Crowdsource food data - users can add foods to the database
 */
import React from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const FoodContributionModal = ({
  isOpen,
  onClose,
  userId,
  foodContribution,
  setFoodContribution
}) => {
  if (!isOpen) return null;

  const handleSubmit = async () => {
    if (!foodContribution.foodName || !foodContribution.calories) {
      alert('Please provide at least food name and calories');
      return;
    }
    try {
      const response = await fetch(`${BACKEND_URL}/api/food-knowledge/add`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          user_id: userId,
          food_name: foodContribution.foodName,
          description: foodContribution.description,
          calories: parseInt(foodContribution.calories),
          protein: parseFloat(foodContribution.protein) || 0,
          carbs: parseFloat(foodContribution.carbs) || 0,
          fat: parseFloat(foodContribution.fat) || 0,
          serving_size: foodContribution.servingSize
        })
      });
      if (response.ok) {
        alert('Thank you! This food has been added to our database and will help identify similar foods in the future.');
        onClose();
        setFoodContribution({ foodName: '', description: '', calories: '', protein: '', carbs: '', fat: '', servingSize: '' });
      } else {
        alert('Failed to add food. Please try again.');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Failed to add food.');
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2 className="heading-3">Teach the App</h2>
        <p className="modal-description">Help improve our food database by adding this food</p>
        
        <div className="meal-plan-form">
          <div className="form-group">
            <label>Food Name</label>
            <input type="text" className="search-input" placeholder="e.g., Homemade Lasagna"
              value={foodContribution.foodName}
              onChange={(e) => setFoodContribution({...foodContribution, foodName: e.target.value})} />
          </div>
          <div className="form-group">
            <label>Description</label>
            <textarea className="manual-entry-textarea" placeholder="Describe the food, ingredients, preparation..."
              value={foodContribution.description}
              onChange={(e) => setFoodContribution({...foodContribution, description: e.target.value})} rows="3" />
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Calories</label>
              <input type="text" inputMode="decimal" className="search-input" placeholder="500"
                value={foodContribution.calories}
                onChange={(e) => setFoodContribution({...foodContribution, calories: e.target.value})} />
            </div>
            <div className="form-group">
              <label>Serving Size</label>
              <input type="text" className="search-input" placeholder="1 plate"
                value={foodContribution.servingSize}
                onChange={(e) => setFoodContribution({...foodContribution, servingSize: e.target.value})} />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Protein (g)</label>
              <input type="text" inputMode="decimal" className="search-input" placeholder="30"
                value={foodContribution.protein}
                onChange={(e) => setFoodContribution({...foodContribution, protein: e.target.value})} />
            </div>
            <div className="form-group">
              <label>Carbs (g)</label>
              <input type="text" inputMode="decimal" className="search-input" placeholder="50"
                value={foodContribution.carbs}
                onChange={(e) => setFoodContribution({...foodContribution, carbs: e.target.value})} />
            </div>
            <div className="form-group">
              <label>Fat (g)</label>
              <input type="text" inputMode="decimal" className="search-input" placeholder="20"
                value={foodContribution.fat}
                onChange={(e) => setFoodContribution({...foodContribution, fat: e.target.value})} />
            </div>
          </div>
          <button className="btn-primary full-width" onClick={handleSubmit}>Add to Database</button>
        </div>
        <button className="btn-secondary full-width" onClick={onClose}>Cancel</button>
      </div>
    </div>
  );
};

export default FoodContributionModal;
